'use client';

import type React from 'react';
import {
  DigitCell,
  DigitClip,
  DigitTrack,
  RollingNumberContainer,
  Separator
} from './RollingNumber.styles';

const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

type DigitColumnProps = { digit: number };

function DigitColumn({ digit }: DigitColumnProps) {
  return (
    <DigitClip>
      <DigitTrack
        style={
          {
            '--roll-to': `translateY(${-(digit + 10)}em)`
          } as React.CSSProperties
        }
      >
        {DIGITS.map((d, i) => (
          <DigitCell key={i}>{d}</DigitCell>
        ))}
      </DigitTrack>
    </DigitClip>
  );
}

type OwnProps = {
  value: number;
};

export default function RollingNumber({ value }: OwnProps) {
  const formatted = value.toLocaleString('en-US');
  const chars = formatted.split('');

  return (
    <RollingNumberContainer aria-label={formatted}>
      {chars.map((char, i) => {
        if (char < '0' || char > '9') {
          return <Separator key={`s${i}`}>{char}</Separator>;
        }

        return <DigitColumn key={`d${i}`} digit={Number(char)} />;
      })}
    </RollingNumberContainer>
  );
}
